<template>
  <el-form hide-required-asterisk :model="loginform" :rules="loginFormRules" ref="loginFormRef" class="login_from">
    <div style="position: relative">
      <el-form-item prop="username" label="手机号" label-width="100%">
        <el-input placeholder="手机号" v-model.trim="loginform.username"></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码" label-width="100%">
        <el-input placeholder="密码" v-model="loginform.password" type="password"></el-input>
      </el-form-item>
    </div>
    <div class="forget_password">
      <span @click="$emit('ChangeForgetPwd', true)">忘记密码？</span>
    </div>
    <div class="login_btn">
      <el-button @click="login">登录</el-button>
    </div>
  </el-form>
</template>

<script>
import { login } from '@/api/user'
export default {
  data () {
    return {
      loginform: {
        grant_type: 'password',
        client_id: 'client-app',
        client_secret: '123456',
        username: '',
        password: '',
        type: 'ADMIN'
      },
      loginFormRules: {
        username: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: this.$FormRules.checkPhone,
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginFormRef.validate(vaild => {
        if (!vaild) return
        login(this.$qs.stringify(this.loginform)).then((res) => {
          if (res.data.access_token) {
            this.$emit('isLogin', res)
          }
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
@deep: ~">>>";
</style>
